import { useEffect } from 'react';
import { useTitle, useWebdata, useMediaQuery } from '../HooksPublic';
import { Button } from 'react-frontier';
import { Carrousel, Product } from '../components';
import { CDN_URL } from '../ConfigPublic';
import { Link } from 'react-router-dom';

import '../style/landing.scss';

var Landing = () => {
	var { setTitle } = useTitle();
	var webdata = useWebdata();
	var isMobile = useMediaQuery('(max-width: 600px)');
	useEffect(() => {
		setTitle('COCOAN - Chocolatería Sincera', false);
	}, []);

	var renderLandingTitle = () => {
		var title = webdata?.variables?.landing_category_title || 'Tu siguiente antojo';
		var words = title.split(' ');
		if(words.length <= 1) return title;
		var lastWord = words.pop();
		return <>
			<span className="font-graphik">{words.join(' ') + ' '}</span>
			<span className="font-homemade-apple">{lastWord}</span>
		</>;
	};

	return <main className='co landing'>
		<header className='landing-hero'>
			{isMobile ? (
				<video
					src={`${CDN_URL}/static/landing/BANNER_LANDING_MOBILE.webm`}
					autoPlay
					muted
					loop
					playsInline
					className="bg-video mobile-video"
					preload="auto"
				/>
			) : (
				<video
					src={`${CDN_URL}/static/landing/BANNER_LANDING_DESKTOP.webm`}
					autoPlay
					muted
					loop
					playsInline
					className="bg-video desktop-video"
					preload="auto"
				/>
			)}

			{/* <div className="masthead-content">
				<h1 className="text" style={{ fontWeight: 'bold' }}>
					<span className="font-graphik">El Regalo perfecto,</span> <br />
					<span className="font-homemade-apple">está aquí.</span>
				</h1>
				<Button
					className="video-button"
					as={Link}
					size="big"
					to={'/shop'}
					text="Quiero comprar"
					style={{ maxWidth: 200, width: '100%', border: '2px solid #fff', color: '#fff', background: 'transparent' }}
				/>
			</div> */}
		</header>

		<section className="landing-inner">
			<Carrousel title={renderLandingTitle()}>
				{!webdata ? (
					(new Array(5).fill(0)).map((a, i) => (
						<Product placeholder product={null} className="landing-product" key={`lnd-prodplh-${i}`} />
					))
				) : (
					webdata.landing_products.map(a => (
						<Product product={a} className="landing-product" key={`lnd-prod-${a.product_id}`} />
					))
				)}
			</Carrousel>
			<Button text='Ver más' as={Link} to={'/shop'} style={{ display: 'block', width: 'auto', maxWidth: 200, margin: '30px auto 0', border: '1.5px solid #222', color: '#222', background: 'transparent', borderRadius: 30, padding: '10px 40px', fontWeight: 600 }} />
		</section>

		<section className="landing-banner">
			{isMobile ? (
				<img src={`${CDN_URL}/static/landing/BANNER_HAZLO_MOBILE.webp`} alt="Hazlo a tu manera" className="full-image" loading="lazy" />
			) : (
				<img src={`${CDN_URL}/static/landing/BANNER_HAZLO.webp`} alt="Hazlo a tu manera" className="full-image" loading="lazy" />
			)}
			<div className="banner-overlay">
				<h2>
					<span className="font-graphik-bold">Hazlo con amor,<br /> dilo con </span>
					<span className="font-homemade-apple">chocolate.</span>
				</h2>
				<p>Chocolate original y sincero para cualquier momento,<br />encuentra la mejor versión de tu chocolate favorito.</p>
			</div>
		</section>

		<section className="events-carousel-section">
			<h2 className="carousel-title">
				<span className="font-graphik-bold">Encuentra tu </span><br />
				<span className="font-homemade-apple">Chocolate Especial</span>
			</h2>
			<div className="events-carousel-track">
				{[...Array(2)].map((_, setIdx) => (
					<div className="events-carousel-set" key={`carousel-set-${setIdx}`} aria-hidden={setIdx > 0}>
						{["Tabletas", "Toffee", "Confitería", "Chocolate Original", "Gelatos", "Berry Cups", "Regalos"].map((event, i) => (
								<span className="event-item font-homemade-apple" key={`event-${setIdx}-${i}`}>
									{event}
									<span className="separator">•</span>
								</span>
							))}
						</div>
					))}
			</div>
		</section>

		<section className="landing-inner-section">
			<div className="landing-customized">
				<div className="customized-row">
					<div className="customized-text mobile-order-2">
						<h3 className="font-graphik-bold">Personalizados <br /><span className="font-homemade-apple">Sociales</span></h3>
						<p className="font-graphik-light">Sorprende en tus eventos con un detalle de chocolate único y especial, perfecto para compartir.</p>
						<Button text='Ver más' as={Link} to={'/personalizados-sociales'} color='black' />
					</div>
					<div className="customized-image mobile-order-1">
						<img src={`${CDN_URL}/static/landing/PERSONALIZADO_SOCIAL.webp`} alt="Sociales" loading="lazy" />
					</div>
				</div>
				<div className="customized-row mt-60">
					<div className="customized-image">
						<img src={`${CDN_URL}/static/landing/PERSONALIZADO_EMPRESARIAL.webp`} alt="Empresariales" loading="lazy" />
					</div>
					<div className="customized-text">
						<h3 className="font-graphik-bold">Personalizados <span className="font-homemade-apple">Empresariales</span></h3>
						<p className="font-graphik-light">El detalle ideal para tus clientes y equipo, chocolates corporativos hechos a la medida.</p>
						<Button text='Ver más' as={Link} to={'/personalizados-empresariales'} color='black' />
					</div>
				</div>
			</div>
		</section>

		{/* <header className='rewards-hero'>
			<picture>
				<source media="(max-width: 600px)" srcSet={`${CDN_URL}/static/landing/BANNER_REWARDS_MOBILE.webp`} />
				<img src={`${CDN_URL}/static/landing/BANNER_REWARDS.webp`} alt="Rewards Cocoan" className="full-image" loading="lazy" />
			</picture>
			<div className='hero-overlay'>
				<span className='welcome-tag font-graphik-bold'>Welcome to the</span>
				<img src={`${CDN_URL}/static/rewards/BANNER_TEXT_REWARDS.webp`} alt='COCOAN Club Rewards' className='hero-text-img' />
				<Button 
					text='Únete ahora' 
					size='big' 
					style={{ position: 'absolute', top: '62%', marginTop: 15, border: '2px solid #fff', color: '#fff', background: 'transparent', maxWidth: 200, width: '100%' }} 
				/>
			</div>
		</header> */}
	</main>
}

export default Landing;